<div class="max-auto plMd prMd sa-grid">
    <div class="sa-col-5 sa-grid-sm-mb">
        <img [src]="imgSrc" alt="">
    </div>
    <div class="sa-col-7 sa-grid-lg-ml">
        <p class="p p--heading text-dark mb20 sa-article-text--{{size}}">{{ text }}</p>
    </div>
</div>